class RangeSliderChoose {
    constructor(el, opts) {
        if (!el) {
            console.error('RangeSliderFilter constructor can\'t find given "el" in DOM!');
            return;
        }

        let inputs = el.querySelectorAll('input');
        let type   = el.dataset.sliderType;
        let inpMin = inputs[0];
        let inpMax = inputs[1];

        let currentMinVal;
        let currentMaxVal;
        let startForRange = [];
        let connectValue = [];

        if ( inpMax !== undefined ) {
            currentMinVal = parseInt(inpMin.value.replace(/\ /g,''));
            currentMaxVal = parseInt(inpMax.value.replace(/\ /g,''));
            startForRange = [currentMinVal, currentMaxVal];
            connectValue = [false, true, false];
        } else {
            currentMinVal = parseInt(inpMin.value.replace(/\ /g,''));
            startForRange = [currentMinVal];
            connectValue = [true, false];
        }

        let inlineElOpts = JSON.parse(el.dataset.sliderRange);
        let minVal = inlineElOpts.min;
        let maxVal = inlineElOpts.max;
        let step = inlineElOpts.step;

        let options = {
            start: startForRange,
            step: step,
            behaviour: 'unconstrained-tap',
            connect: connectValue,
            range: {
                'min': minVal,
                'max': maxVal
            },
            format: wNumb({
                decimals: 0,
                thousand: ' '
            })
        };

        noUiSlider.create(el, options);

        el.noUiSlider.on('update', function (values, handle) {
            let min = parseInt(values[0].replace(/\ /g,''));
            let max = parseInt(values[1].replace(/\ /g,''));


            if ( type === 'floor' ) {
                let floorNotFirst    = $('[data-floor-not-first]');
                let floorNotLast     = $('[data-floor-not-last]');

                if ( values[0] <=  minVal || values[1] <= minVal) {
                    floorNotFirst.prop('checked', false);
                }
                if ( values[1] >= maxVal || values[0] >= maxVal) {
                    floorNotLast.prop('checked', false);
                }
            }
            window.requestAnimationFrame(() => {
                // если минимальное значение ползунка больше максимального,
                // то меняем местами значения инуптов, чтобы ползунки перескакивали друг через друга
                if ( min >= max ) {
                    inpMin.value = values[1];
                    inpMax.value = values[0];
                    $(inpMin).addClass('reverseMax');
                    $(inpMax).addClass('reverseMin');
                    $(inpMin).trigger('change');
                    $(inpMax).trigger('change');
                } else {
                    inpMin.value = values[0];
                    inpMax.value = values[1];
                    $(inpMin).removeClass('reverseMax');
                    $(inpMax).removeClass('reverseMin');
                    $(inpMin).trigger('change');
                    $(inpMax).trigger('change');
                }
            });
        });

        inputs.forEach(function (input, handle) {
            input.addEventListener('change', function () {
                let isReverseMax = $(this).hasClass('reverseMax');
                let isReverseMin = $(this).hasClass('reverseMin');
                console.log('this', $(this).val())
                if ( isReverseMax || isReverseMin ) {
                    el.noUiSlider.setHandle(!handle, this.value);
                } else {
                    el.noUiSlider.setHandle(handle, this.value);
                }
                // if ( isReverseMax ) {
                //     if ( $(inpMin).val() > $(inpMax).val() ) {
                //
                //     }
                // }

            });
        });

        // if ( type === 'floor' ) {
        //     let floorNotFirst    = $('[data-floor-not-first]');
        //     let floorNotLast     = $('[data-floor-not-last]');
        //     let floorFirstValue  = minVal;
        //     let floorLastValue   = maxVal;
        //
        //     floorNotFirst.on('change', function () {
        //         let isChecked = $(this).prop('checked');
        //         let floorFrom   = $('input[name="floor_from"]');
        //         let valInp    = Number(floorFrom.val());
        //         if ( isChecked ) {
        //             if (  valInp === floorFirstValue && !floorFrom.hasClass('reverseMax') ) {
        //                 el.noUiSlider.set([floorFirstValue + 1, null]);
        //             }
        //             if ( floorFrom.hasClass('reverseMax') && valInp <= floorFirstValue ) {
        //                 el.noUiSlider.set([null, floorFirstValue + 1]);
        //             }
        //         } else {
        //             // el.noUiSlider.set([floorFirstValue, null]);
        //         }
        //     });
        //
        //     floorNotLast.on('change', function () {
        //         let isChecked = $(this).prop('checked');
        //         let floorTo   = $('input[name="floor_to"]');
        //         let valInp    = Number(floorTo.val());
        //         if ( isChecked ) {
        //             if (  valInp === floorLastValue && !floorTo.hasClass('reverseMin') ) {
        //                 el.noUiSlider.set([null, floorLastValue - 1]);
        //             }
        //             if ( floorTo.hasClass('reverseMin') && valInp >= floorLastValue) {
        //                 el.noUiSlider.set([floorLastValue - 1, null]);
        //             }
        //
        //         } else {
        //             // el.noUiSlider.set([null, floorLastValue]);
        //         }
        //     });
        // }
    }
}